import React from "react";

export default function StatCard({ title, value, hint, icon, tone = "primary" }) {
  const hintColor =
    tone === "success"
      ? "var(--text-tertiary)"
      : tone === "warn"
      ? "var(--text-secondary)"
      : "var(--text-primary)";

  return (
    <div className="adm-card">
      <div>
        <h4>{title}</h4>
        <div className="adm-value">{value}</div>
        {hint && (
          <div className="adm-hint" style={{ color: hintColor }}>
            {hint}
          </div>
        )}
      </div>

      <div className="adm-pill">{icon}</div>
    </div>
  );
}